/* eslint-disable no-console */

import { register } from 'register-service-worker'

register(`${process.env.BASE_URL}service-worker.js`, {
  ready() {},
  registered(registration) {
    console.log('Service worker has been registered.')
    document.dispatchEvent(
      new CustomEvent('serviceWorkerRegistered', {
        detail: registration,
      })
    )

    // Check for updates of the app every 10s. This is for users that leave it
    // running over long periods of time, so that the app updates itself if necessary.
    setInterval(() => {
      registration.update()
    }, 1000 * 10)
  },
  cached() {
    console.log('Content has been cached for offline use.')
  },
  updatefound() {
    console.log('New content is downloading.')
  },
  updated(registration) {
    console.log('New content is available. Please refresh.')
    // Inform the app that an update is available.
    document.dispatchEvent(
      new CustomEvent('serviceWorkerUpdateAvailable', {
        detail: registration,
      })
    )
  },
  offline() {
    document.dispatchEvent(new CustomEvent('appIsOffline'))
    console.log('No internet connection found. App is running in offline mode.')
  },
  error(err) {
    console.error('Error during service worker registration:', err)
  },
})
